/**
 * API Endpoints Constants
 * All API endpoints are defined here for easy management
 */

const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: '/api/public/Auth/login',
    REGISTER: '/api/public/Auth/register',
    REFRESH_TOKEN: '/api/public/Auth/refresh',
    REVOKE: '/api/public/Auth/revoke',
    FORGOT_PASSWORD: '/api/public/Auth/forgot-password',
    VERIFY_OTP: '/api/public/Auth/verify-otp',
    RESET_PASSWORD: '/api/public/Auth/reset-password',
    VERIFY_EMAIL: '/api/public/Auth/verify-email',
  },
  
  // User endpoints
  USER: {
    PROFILE: '/api/user/profile',
    UPDATE_PROFILE: '/api/Customer/update-profile',
    CHANGE_PASSWORD: '/api/Customer/change-password',
  },
  
  // Utilities endpoints
  UTILITIES: {
    UPLOAD_BASE64_SINGLE: '/api/Utilities/upload/base64/single',
    DETECT_COUNTRY: '/api/Utilities/detect-country',
    GET_CURRENCY: '/api/Utilities/get-currency',
    GET_CURRENCIES: '/api/Utilities/get-currencies',
  },
  
  // Vehicle endpoints
  VEHICLE: {
    SEARCH_AVAILABLE: '/api/Vehicle/search-available',
    GET_FILTERS: '/api/Vehicle/get-filters',
    GET_FEATURED: '/api/Vehicle/get-featured',
    SEARCH_ADDRESS: '/api/Vehicle/search-address',
  },
  
  // Booking endpoints
  BOOKING: {
    CREATE: '/api/Booking/create',
    MY_BOOKINGS: '/api/Booking/my-bookings',
    GET_BY_ID: '/api/Booking/get-by-id',
    UPDATE_CUSTOMER: '/api/Booking/update-customer',
  },

  // Fiserv Connect payment
  PAYMENT: {
    CREATE_SESSION: '/api/Payment/create-session',
    RETRY: '/api/Payment/retry',
    SESSION_STATUS: '/api/Payment/session-status',
  },

  // Tour endpoints
  TOUR: {
    GET_FEATURED: '/api/Tour/get-featured',
    DESTINATIONS: '/api/Tour/destinations',
    SEARCH: '/api/Tour/search',
    GET_BY_ID: '/api/Tour/get-by-id',
    AVAILABILITY: '/api/Tour/availability',
    CATEGORIES: '/api/Tour/categories',
  },

  TOUR_BOOKING: {
    CREATE: '/api/TourBooking/create',
    MY_BOOKINGS: '/api/TourBooking/my-bookings',
    GET_BY_ID: '/api/TourBooking/get-by-id',
    UPDATE_SLOT: '/api/TourBooking/update-slot',
  },

  // Inquiry endpoints
  INQUIRIES: {
    ADD: '/api/public/Inquiries/add',
    ADD_NEWSLETTER: '/api/public/Inquiries/add-newsletter',
  },
  
  // Add more endpoints as needed
};

export default API_ENDPOINTS;

